import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import {
  isGuest,
  isWellnessUser,
  NavigateConst,
  ANALYTICS_MESSAGES,
  generateCustomAdobeContentTitle,
  useAnalytics,
} from 'common';
import { GlobalContext, isAvMed } from 'context';
import { useNavigate } from 'react-router-dom';
import { FooterLinks } from '@sentara-health/optimahealth_web';

const Footer = () => {
  const { t } = useTranslation();
  const { getFeature,ssoEndPoints } = useContext(GlobalContext);
  const navigate = useNavigate();
  const { trackContentListing } = useAnalytics();

  // Redirect to Oracle contact us page
  const redirectToContact = async (e: Event) => {
  // Prevent the default action of the event
  e.preventDefault();
  const guestValue: boolean = await isGuest();
  const wellnessValue: boolean = await isWellnessUser();
  const isPublicContactUs = guestValue || wellnessValue;
  // Check if ContactusSalesForce property of getFeature is falsy
  if(!getFeature?.ContactusSalesForce) {
    // If it's falsy, find the form with id 'contactUS' and submit it
    const form = document.getElementById('contactUS') as HTMLFormElement;
    form.submit();
  } 
  else if (getFeature?.MaintenancePage) {
    window.open(ssoEndPoints?.contactUs,'_blank');
  }
  else {
    // If it's wellness or Guest, navigate to public contact us page, else navigate to internal contact us page
    if(isPublicContactUs) {
      window.open(ssoEndPoints?.contactUs,'_blank');
      return;
    }
    navigate(NavigateConst.homeContactUs);
  }
};
  // generate footer links
  const footerLinks: Array<{
    dataTestId: string;
    label: string;
    url: string | undefined;
    target?: string;
    onClick?: (e: Event) => void;
  }> = [
    {
      dataTestId: 'footerTermsOfUse',
      label: t('common.termsOfUse'),
      url: ssoEndPoints?.termAndCondition,
      target: '_blank',
    },
    {
      dataTestId: 'footerLangAssist',
      label: t('common.languagesAssistance'),
      url: ssoEndPoints?.languagesAssistance,
      target: '_blank',
    },
    {
      dataTestId: 'footerNoticeOfNonDiscrimination',
      label: t('common.noticeOfNonDiscrimination'),
      url: ssoEndPoints?.footerNoticeOfNonDiscrimination,
      target: '_blank',
    },
    ...(!isAvMed() && getFeature?.ContactUs
      ? [
          {
            dataTestId: 'footerContactUs',
            label: t('common.contactUs'),
            url: '#',
            onClick: (e: Event) => redirectToContact(e),
          },
        ]
      : []),
    ...(getFeature?.AccessibilityStatement
      ? [
          {
            dataTestId: 'footeraccessibilityStatement',
            label: t('common.accessibilityStatement'),
            url: ssoEndPoints?.accessibility,
            target: '_blank',
          },
        ]
      : []),
  ];

  return (
    <FooterLinks
      links={footerLinks.map(({ dataTestId, ...link }, index) => ({
        ...link,
        dataTestId,
        onClick: (e: Event) => {
          trackContentListing(
            dataTestId,
            generateCustomAdobeContentTitle(
              link.label.trim(),
              ANALYTICS_MESSAGES.FOOTER_LINK_CLICK_SUFFIX
            ),
            index + 1
          );
          link.onClick?.(e);
        },
      }))}
    />
  );
};

export default Footer;
